import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, googleProvider } from "../Firebase"; 
import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [profileData, setProfileData] = useState(null);

    const loginWithGoogle = () => signInWithPopup(auth, googleProvider);

    const logout = () => {
        setProfileData(null);
        return signOut(auth);
    };

    const authFetch = async (url, options = {}) => {
        let token = null;
        if (auth.currentUser) {
            try {
                token = await auth.currentUser.getIdToken();
            } catch (err) {
                console.error("Failed to get Firebase token:", err);
            }
        }

        const headers = new Headers(options.headers || {});
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }

        return fetch(url, {
            ...options,
            headers,
        });
    };

    const refetchProfile = async () => {
        if (!currentUser || !currentUser.email) {
            setProfileData(null);
            return null;
        }
        try {
            const res = await authFetch("https://techfest.org/api/google-signin/", {
                method: "POST"
            });
            const data = await res.json();
            if (res.ok) {
                setProfileData(data);
                return data;
            }
        } catch (e) {
            console.error("Failed to fetch profile", e);
        }
        return null;
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user);
            setLoading(false);
        });
        return unsubscribe; // cleanup on unmount
    }, []);

    // Whenever currentUser changes, fetch profile data
    useEffect(() => {
        if (currentUser?.email) {
            refetchProfile();
        } else {
            setProfileData(null);
        }
    }, [currentUser]);

    const value = {
        currentUser,
        loginWithGoogle,
        logout,
        profileData,
        refetchProfile,
        setProfileData,
        authFetch,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
